<template>
  <div class="c-buttonAdmin" :style="styles">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    width: String,
  },
  computed: {
    styles() {
      return {
        width: this.width,
      };
    },
  },
};
</script>

<style></style>
